import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';

import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import DocumentosController from '@/assets/ts/controller/DocumentosController';
import FileUtils from '@/../bower_components/teknisavuecomponents/assets/utils/FileUtils';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';

@Component({
  name: 'NovaAssinaturaRelatorio',
  components: {
    TkForm,
  },
})
class NovaAssinaturaRelatorio extends Vue {
  // #region [ PROPS ]
  @Prop({ default: true })
  private showFileField: boolean;

  @Prop({ default: null })
  private row: any;

  @Prop({ default: false })
  private value: boolean;
  // #endregion

  // #region [ EVENTS ]
  @Emit('after-save')
  private emitAfterSave() {}

  @Emit('input')
  private emitInput(value: boolean) {}
  // #endregion

  // #region [ DATA ]
  private internalValue = false;
  private loading = false;

  private readonly defaultRow = {
    IDTIPOASSINATURA: 'ELETRONICA',
  };

  private internalRow: any = {};

  private categorias = [];
  private tipos = [];

  private categoriasLoaded = false;
  private tiposLoaded = false;

  private base64 = '';
  // #endregion

  // #region [ COMPUTED ]
  private get fields(): Field[] {
    const fields = [
      {
        name: 'NMDOCUMENTO',
        label: 'Nome do Documento',
        type: 'text',
        size: 12,
        required: true,
      },
      {
        name: 'NRCATEGDOCUMENTO',
        label: 'Categoria',
        type: 'autocomplete',
        descriptionField: 'NMCATEGDOCUMENTO',
        valueField: 'NRCATEGDOCUMENTO',
        items: this.categorias,
        size: 6,
        required: true,
      },
      {
        name: 'NRTIPODOCUMENTO',
        label: 'Tipo',
        type: 'autocomplete',
        descriptionField: 'NMTIPODOCUMENTO',
        valueField: 'NRTIPODOCUMENTO',
        items: this.tipos,
        size: 6,
        required: true,
      },
      {
        name: 'IDTIPOASSINATURA',
        label: 'Tipo de Assinatura',
        type: 'select',
        descriptionField: 'description',
        valueField: 'value',
        items: [
          {
            value: 'ELETRONICA',
            description: 'Eletrônica',
          },
          {
            value: 'DIGITAL',
            description: 'Digital',
          },
        ],
        size: 6,
        required: true,
      },
    ];

    return fields;
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;

    if (this.internalValue) {
      this.loadFields();

      this.internalRow = {
        ...(this.row || {}),
        ...this.defaultRow,
      };
    }
  }
  // #endregion

  // #region [ METHODS ]
  private closeDialog() {
    this.internalValue = false;
    this.emitInput(this.internalValue);
  }

  private async save() {
    if (!this.validate()) {
      return;
    }

    this.loading = true;

    try {
      const internalRow = {
        ...this.internalRow,
      };

      await DocumentosController.saveAssinatura(internalRow, false);

      this.closeDialog();
      this.emitAfterSave();
    } finally {
      this.loading = false;
    }

  }

  private async loadFields() {
    this.loading = true;

    try {
      await this.loadCategorias();
      await this.loadTipos();
    } finally {
      this.loading = false;
    }
  }

  private async loadCategorias() {
    if (!this.categoriasLoaded) {
      this.categorias = await DocumentosController.getCategorias(false);
      this.categoriasLoaded = true;
    }
  }

  private async loadTipos() {
    if (!this.tiposLoaded) {
      this.tipos = await DocumentosController.getTipos(false);
      this.tiposLoaded = true;
    }
  }

  private validate(): boolean {
    const isValid: boolean = (this.$refs.form as any).validate(true);

    return isValid;
  }
  // #endregion
}

export default NovaAssinaturaRelatorio;